<small *ngIf="!shipment && !error" class="text-muted" >Loading shipment...</small>
<small *ngIf="error" class="text-danger">Error</small>

<app-shipment-diagram *ngIf="shipment" [shipment]="shipment"></app-shipment-diagram>
